import { axiosGet } from "../../Helpers";

export const loadAdminDashboardStats = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("user/adminStatistics");
  setLoading(false);
  const data = response.data?.data;
  console.log("stats data", data);
  return data;
};
